import React from 'react';
import type {ScreenProps} from 'src/types/Screen';
export default React.createContext<ScreenProps>(undefined);
